import { useState } from 'react';

import { ValidationErrors } from '../../../../modals/order-method/OrderMethodModal';
import { GooglePlaceResource } from '../../../../services/resources/GooglePlaceResource';
import { DeliveryAddressSchema } from '../../modals/delivery-address/form/schema';
import { CompanyDetailsInterface, GoogleLocationInterface } from '../../../../services/exports/Interfaces';
import { selectCompany } from '../../../../store/slices/InitialDataSlice';
import { useSelector } from 'react-redux';

const useGetDeliveryLocation = (company: CompanyDetailsInterface) => {
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState<ValidationErrors>(null);
  const franchise = useSelector(selectCompany);

  async function getLocation(
    data: DeliveryAddressSchema,
    selectedPlace?: GooglePlaceResource,
  ): Promise<GoogleLocationInterface<google.maps.LatLng>> {
    setValidationError(null);

    if (selectedPlace) {
      return { success: true, location: selectedPlace.getCoordinates() };
    }

    setLoading(true);

    const res = await new GooglePlaceResource().getLocation({
      streetName: data.delivery_street_name,
      streetNumber: data.delivery_street_number,
      zip: data.delivery_zip_code,
      city: data.delivery_city,
      state: company?.state ?? franchise.state,
      country: company?.country ?? franchise.country,
    });

    setLoading(false);

    if (!res.success) {
      setValidationError(ValidationErrors.address_not_found);
    }

    return res;
  }
  const resetError = () => setValidationError(null);

  return { loading, validationError, getLocation, resetError };
};

export default useGetDeliveryLocation;
